import { PageItemTranslationDto } from 'api/dto/old/PageItemTranslations.dto';
import { PageItemApi } from 'api/PageItemApi';
import { PageItemModel, mapPageItemDtoToModel, mapPageItemModelToDto } from 'api/dto/PageItem.dto';
import { LangCodeEnum } from 'shared/enums/LangCodeEnum';

export class PageItemRepository {
  constructor(private pageItemApi: PageItemApi) {}

  list(pageId: number): Promise<PageItemModel[]> {
    return this.pageItemApi
      .list(pageId)
      .then((entries) => entries.map((entry) => mapPageItemDtoToModel(entry)));
  }

  create(
    pageId: number,
    model: PageItemModel,
    shouldSendFormData?: boolean,
  ): Promise<PageItemModel> {
    return this.pageItemApi
      .create(pageId, mapPageItemModelToDto(model), shouldSendFormData)
      .then((entry) => mapPageItemDtoToModel(entry));
  }

  createAndList(pageId: number, model: PageItemModel): Promise<PageItemModel[]> {
    return this.create(pageId, model).then(() => this.list(pageId));
  }

  savePageItemTranslations({
    itemId,
    translations,
  }: {
    itemId: number;
    translations: PageItemTranslationDto[];
  }): Promise<any> {
    // TODO: check what's returned and if we want to use it
    return this.pageItemApi.savePageItemTranslations({ itemId, translations });
  }

  getTranslatedPageItem({
    itemId,
    language,
  }: {
    itemId: number;
    language: LangCodeEnum;
  }): Promise<PageItemModel> {
    return this.pageItemApi
      .getTranslatedPageItem({ itemId, language })
      .then((pageItemEntry) => mapPageItemDtoToModel(pageItemEntry));
  }

  updateAndList(
    model: PageItemModel,
    pageId: number,
    shouldSendFormData?: boolean,
  ): Promise<PageItemModel[]> {
    return this.pageItemApi
      .update(mapPageItemModelToDto(model), shouldSendFormData)
      .then(() => this.list(pageId));
  }

  update(model: PageItemModel, shouldSendFormData?: boolean): Promise<PageItemModel> {
    return this.pageItemApi
      .update(mapPageItemModelToDto(model), shouldSendFormData)
      .then((entry) => mapPageItemDtoToModel(entry));
  }

  reorder(pageId: number, position: number, model: PageItemModel): Promise<PageItemModel[]> {
    let serialized = mapPageItemModelToDto(model);

    if ('options' in serialized && serialized.options) {
      serialized.options = serialized.options.map(({ id, option, position }) => ({
        id,
        option,
        position,
      }));
    }

    return this.pageItemApi.reorder(pageId, position, serialized).then(() => this.list(pageId));
  }

  move(pageId: number, itemId: number, position: number): Promise<PageItemModel[]> {
    return this.pageItemApi.move(pageId, itemId, position).then(() => this.list(pageId));
  }

  delete(itemId: number, pageId: number): Promise<PageItemModel[]> {
    return this.pageItemApi.delete(itemId).then(() => this.list(pageId));
  }

  moveToPulseProject(itemId: number, projectId: number): Promise<void> {
    return this.pageItemApi.moveToPulseProject(itemId, projectId);
  }
}
